import { useEffect, useRef, useState } from 'react';
import OTPConfig from '../config';
import { lastNChars, numbersIn } from '../../../utils/common/common';
import OTPInput from './OTPInput';
import { useOnMessage } from '../../../utils/hooks';
import WalletAlpha from '../../../services/walletAlpha/walletAlpha';

function OTPForm({ onOTPCompleted }: OTPFormProps) {
  const inputNumbers = Array.from(Array(OTPConfig.NUMBER_OF_OTP_INPUTS).keys());
  const inputsRefs = inputNumbers.map(() => useRef<HTMLInputElement>(null));
  const [inputValues, setInputValues] = useState<string[]>(inputNumbers.map(() => ''));

  useOnMessage(WalletAlpha.messages.NUVEM_CLEAR_INPUTS, async () => {
    setInputValues(inputNumbers.map(() => ''));
  });

  useEffect(() => {
    const otpCode: string = inputValues.join('');

    if (otpCode.length === OTPConfig.NUMBER_OF_OTP_INPUTS) {
      onOTPCompleted(otpCode);
    }
  }, inputValues);

  const onChange = (value: string, inputNumber: number) => {
    const newValues = [...inputValues];
    newValues[inputNumber] = value;
    setInputValues(newValues);
  };

  const onPaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const rawData = event.clipboardData.getData('text');
    const otpCode = lastNChars(OTPConfig.NUMBER_OF_OTP_INPUTS, numbersIn(rawData));

    setInputValues(otpCode.split(''));
    event.preventDefault();
  };

  return (
    <>
      {inputNumbers.map((inputNumber: number) => (
        <OTPInput
          innerRef={inputsRefs[inputNumber]}
          inputNumber={inputNumber}
          key={inputNumber}
          onChangeValue={(value: string) => onChange(value, inputNumber)}
          onPaste={onPaste}
          value={inputValues[inputNumber]}
          nextOTPInputRef={inputsRefs[inputNumber + 1]}
          previousOTPInputRef={inputsRefs[inputNumber - 1]}
        />
      ))}
    </>
  );
}

export default OTPForm;
